import React from 'react';
import { Link } from 'react-router-dom';
import {
  Home, Building2, TreePine, Hammer, Sparkles, Mountain,
} from 'lucide-react';

/**
 * Quick-pick property type chips shown directly below the homepage
 * search bar. One tap takes the buyer straight to a long-tail SEO
 * landing page (or the listings page in the case of New Homes).
 *
 * Six chips chosen by Irish-market search volume:
 *   Detached · Apartment · Townhouse · Bungalow · Site (planning) · New Homes
 *
 * Icons via lucide-react to match the rest of the app — no emoji.
 */
const CHIPS = [
  { label: 'Detached',             icon: Home,       to: '/type/detached' },
  { label: 'Apartment',            icon: Building2,  to: '/type/apartment' },
  { label: 'Townhouse',            icon: Hammer,     to: '/type/townhouse' },
  { label: 'Bungalow',             icon: Mountain,   to: '/type/bungalow' },
  { label: 'Site with planning',   icon: TreePine,   to: '/type/site-with-planning' },
  { label: 'New Homes',            icon: Sparkles,   to: '/listings?newHome=1',
    highlight: true },
];

const PropertyTypeChips = () => {
  return (
    <div
      className="flex flex-wrap items-center justify-center gap-2 sm:gap-3 mt-5"
      data-testid="property-type-chips"
    >
      <span className="text-xs uppercase tracking-widest text-white/70 font-medium hidden sm:inline">
        Popular searches:
      </span>
      {CHIPS.map((chip) => {
        const Icon = chip.icon;
        const base =
          'group inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full ' +
          'text-sm font-medium border transition-all backdrop-blur-sm ' +
          'hover:scale-[1.03] hover:shadow-md';
        const variant = chip.highlight
          ? 'bg-amber-400/95 border-amber-300 text-gray-900 hover:bg-amber-400'
          : 'bg-white/15 border-white/30 text-white hover:bg-white/25';
        return (
          <Link
            key={chip.to}
            to={chip.to}
            className={`${base} ${variant}`}
            data-testid={`property-chip-${chip.label.toLowerCase().replace(/\s+/g, '-')}`}
          >
            <Icon
              className={`h-3.5 w-3.5 ${
                chip.highlight ? 'text-gray-900' : 'text-white/80 group-hover:text-white'
              }`}
            />
            {chip.label}
          </Link>
        );
      })}
    </div>
  );
};

export default PropertyTypeChips;
